module.exports = __webpack_public_path__ + "img/Flag_of_Montenegro.252745a3.svg";